import { sqliteTable, text, real, integer, index } from "drizzle-orm/sqlite-core";

// ============================================================================
// currencies — สกุลเงิน (Multi-Currency Support)
// ============================================================================
export const currencies = sqliteTable("accounting_currencies", {
  id: text("id").primaryKey(),
  companyId: text("company_id").notNull(),
  code: text("code").notNull(), // ISO 4217: THB, USD, EUR, JPY
  name: text("name").notNull(), // e.g., "Thai Baht", "US Dollar"
  symbol: text("symbol").notNull(), // ฿, $, €, ¥
  exchangeRate: real("exchange_rate").notNull().default(1), // rate to base currency (THB)
  decimalPlaces: integer("decimal_places").notNull().default(2), // number of decimal places for display
  exchangeRateUpdatedAt: text("exchange_rate_updated_at"), // ISO timestamp of last rate change
  rateSource: text("rate_source"), // 'manual' | 'bot' | 'xe' | 'ecb'
  isBaseCurrency: integer("is_base_currency").notNull().default(0),
  isActive: integer("is_active").notNull().default(1),
  createdAt: text("created_at").notNull(),
  createdBy: text("created_by"),
  updatedAt: text("updated_at").notNull(),
  updatedBy: text("updated_by"),
  deletedAt: text("deleted_at"),
  deletedBy: text("deleted_by"),
}, (table) => ({
  cur_company_idx: index("cur_company_idx").on(table.companyId, table.isActive),
  cur_code_idx: index("cur_code_idx").on(table.companyId, table.code),
}));

// Type exports
export type Currency = typeof currencies.$inferSelect;
export type NewCurrency = typeof currencies.$inferInsert;
